import React from "react";
import { CheckCircle2, Download } from "lucide-react";
import { B2B } from "@/constants/testIds";
import { useT } from "@/i18n/LanguageContext";

// Success confirmation block shown after a successful POST /api/inquiries.
// Displays the "Inquiry received" message plus the single-use, token-gated
// portfolio download CTA. `apiBase` is passed in so we don't duplicate the
// environment lookup here.
export default function B2BSuccessBlock({ portfolioToken, apiBase }) {
  const { t } = useT();
  const downloadHref = portfolioToken
    ? `${apiBase}/portfolio?token=${encodeURIComponent(portfolioToken)}`
    : "#";
  return (
    <div
      data-testid={B2B.success}
      className="mt-6 rounded-2xl bg-emerald-50 border border-emerald-200 text-emerald-900 p-5"
    >
      <div className="flex items-start gap-3">
        <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold">{t("b2b.successTitle")}</p>
          <p className="text-sm">{t("b2b.successBody")}</p>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-emerald-200/70">
        <p className="text-sm font-medium text-emerald-900">
          {t("b2b.portfolioReady")}
        </p>
        <a
          data-testid={B2B.portfolioDownload}
          href={downloadHref}
          className="mt-3 group inline-flex items-center gap-3 rounded-full bg-[#001F39] text-white pl-5 pr-2 py-2 text-sm font-medium hover:bg-[#25bfcf] transition-all"
        >
          {t("b2b.portfolioDownload")}
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-[#FFD53F] text-[#001F39]">
            <Download className="w-4 h-4" />
          </span>
        </a>
      </div>
    </div>
  );
}
